import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProductUid } from '@constants';
import { ProductService } from '@services';
import { firstValueFrom } from 'rxjs';
import { ChildPageRoute, GknRoutePath } from 'src/app/app-routing.enum';

/**
 * Indicates a user can activate a route when
 * the currently selected product is {@link ProductUid.GENESYS_CLOUD_CX}.
 * Redirects to Product Knowledge for non-Genesys Cloud products.
 * @returns promised boolean
 */
export const genesysCloudOnlyGuard: CanActivateFn = async (): Promise<boolean> => {
    const productService = inject(ProductService);
    const router = inject(Router);

    const product = await firstValueFrom(productService.selectedProduct$);
    const isGenesysCloud = product?.uid === ProductUid.GENESYS_CLOUD_CX;

    if (isGenesysCloud) return true;

    // NOTE: Guards should handle all cases gracefullly and should not handle or throw errors
    // Guards are single responsibilility and doesn't manage state changes.
    //  Preserve current product selection - don't override it
    // Check if currently on roadmap archives page under home
    if (router.url.includes(`/${GknRoutePath.HOME}/${ChildPageRoute.ROADMAP_ARCHIVES}`)) {
        router.navigate([`/${GknRoutePath.HOME}`], {
            queryParamsHandling: 'merge',
            preserveFragment: true,
        });
    } else {
        // For all other GC-exclusive routes, redirect to Product Knowledge
        router.navigate([`/${GknRoutePath.RESOURCES}/${ChildPageRoute.PRODUCT_KNOWLEDGE}`], {
            queryParamsHandling: 'merge',
            preserveFragment: true,
        });
    }
    return false;
};
